var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 16.6663C9.54134 16.6663 9.14898 16.5031 8.82259 16.1768C8.4962 15.8504 8.33301 15.458 8.33301 14.9997C8.33301 14.5413 8.4962 14.149 8.82259 13.8226C9.14898 13.4962 9.54134 13.333 9.99967 13.333C10.458 13.333 10.8504 13.4962 11.1768 13.8226C11.5031 14.149 11.6663 14.5413 11.6663 14.9997C11.6663 15.458 11.5031 15.8504 11.1768 16.1768C10.8504 16.5031 10.458 16.6663 9.99967 16.6663ZM9.99967 11.6663C9.54134 11.6663 9.14898 11.5031 8.82259 11.1768C8.4962 10.8504 8.33301 10.458 8.33301 9.99967C8.33301 9.54134 8.4962 9.14898 8.82259 8.82259C9.14898 8.4962 9.54134 8.33301 9.99967 8.33301C10.458 8.33301 10.8504 8.4962 11.1768 8.82259C11.5031 9.14898 11.6663 9.54134 11.6663 9.99967C11.6663 10.458 11.5031 10.8504 11.1768 11.1768C10.8504 11.5031 10.458 11.6663 9.99967 11.6663ZM9.99967 6.66634C9.54134 6.66634 9.14898 6.50315 8.82259 6.17676C8.4962 5.85037 8.33301 5.45801 8.33301 4.99967C8.33301 4.54134 8.4962 4.14898 8.82259 3.82259C9.14898 3.4962 9.54134 3.33301 9.99967 3.33301C10.458 3.33301 10.8504 3.4962 11.1768 3.82259C11.5031 4.14898 11.6663 4.54134 11.6663 4.99967C11.6663 5.45801 11.5031 5.85037 11.1768 6.17676C10.8504 6.50315 10.458 6.66634 9.99967 6.66634Z",
    fill: "#66696C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/more_vert.168ce095ebdc4a7d6dbd02dea8fb4d25.svg";
export { ForwardRef as ReactComponent };